import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OperationManagerService } from './operation-manager.service';
import { WarningPopup } from "../../components/shared/warning-popup/warning-popup";

export interface CanComponentDeactivate {
  canDeactivate?: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class PendingOperationGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private opManager: OperationManagerService, private dialog: MatDialog) {}

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | boolean {
    if (component.canDeactivate) {
      const result = component.canDeactivate();
      if (typeof result === 'boolean') {
        if (!result) return false;
      } else {
        return result;
      }
    }

    if (!this.opManager.isOperationRunning) return true;

    const ref = this.dialog.open(WarningPopup, {
      width: '40%',
      data: {
        type:'abortApi',
        message: 'Changing project name, task name or navigating away from the page will abort the current operation. Please confirm whether to abort or continue the ongoing operation.'
      }
    });

    return ref.afterClosed().pipe(
      map(result => {
        if (result === 'confirm') {
          this.opManager.abortOperation();
          return true;
        }
        return false;
      })
    );
  }
}
